import { OpportunitiesFilterBar } from "./components/OpportunitiesFilterBar";
export default OpportunitiesFilterBar;